<div class="content">
  <h2 mat-dialog-title>Confirm Drop</h2>
  <mat-dialog-content class="body">
    <p>You are trying to move <b>{{movePlayer.fn+' '+movePlayer.ln}}</b> to <b>{{player.pick_rp}}</b>.
      <b>{{player.fn+' '+player.ln}}</b>
      is not eligible to fill the <b>{{movePlayer.pick_rp}}</b> position.</p>
    <div class="dRow">
      <div class="player" [ngStyle]="{'background-image':'url(\''+playerURL+movePlayer.pic+'\')'}"></div>
      <div class="arrow"><i class="fas fa-arrow-right"></i></div>
      <div class="position">{{player.pick_rp}}</div>
    </div>
    <div class="dRow">
      <div class="player" [ngStyle]="{'background-image':'url(\''+playerURL+player.pic+'\')'}"></div>
      <div class="arrow"><i class="fas fa-arrow-right"></i></div>
      <div class="ex"><i class="fas fa-times"></i></div>
      <div class="position">{{movePlayer.pick_rp}}</div>
    </div>
    <p>As a result, you will need to drop <b>{{player.fn+' '+player.ln}}</b> and fill the <b>{{movePlayer.pick_rp}}</b>
      position.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close="failure" color="warn">Cancel</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-button mat-dialog-close="success" class="mat-primary mat-raised-button">Drop</button>
  </mat-dialog-actions>
</div>